import React, { useEffect, useState } from "react";
import { FileText, ChevronRight, ClipboardList } from "lucide-react";
import StatusBadge from "../components/StatusBadge";
import { Progress } from "../components/ui/progress";
import FormFiller from "./FormFiller";
import Documents from "./Documents";
import api from "../api";

function Card({ children, className = "" }) {
  return <div className={`rounded-2xl border border-slate-200 bg-white p-5 shadow-sm md:p-6 ${className}`}>{children}</div>;
}

const BADGE = { not_started: "Missing", in_progress: "In progress", submitted: "Pending", approved: "Approved", rejected: "Rejected", returned: "Rejected" };
const LABEL = { not_started: "Not Started", in_progress: "In Progress", submitted: "Submitted", approved: "Approved", rejected: "Rejected", returned: "Returned for Corrections" };

export default function FormsDocuments() {
  const [forms, setForms] = useState([]);
  const [progress, setProgress] = useState({ required_total: 0, approved_required: 0 });
  const [openId, setOpenId] = useState(null);

  const load = () => api.get("/forms").then((r) => {
    setForms(r.data.forms);
    setProgress({ required_total: r.data.required_total, approved_required: r.data.approved_required });
  }).catch(() => {});
  useEffect(() => { if (!openId) load(); }, [openId]);

  if (openId) return <FormFiller formId={openId} onClose={() => setOpenId(null)} />;

  const pct = progress.required_total ? Math.round(progress.approved_required / progress.required_total * 100) : 0;

  return (
    <div className="space-y-6" data-testid="forms-documents">
      <Card>
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-base font-bold text-slate-900">Onboarding forms</h2>
            <p className="text-sm text-slate-500">Complete and e-sign each required form. {progress.approved_required}/{progress.required_total} required forms approved.</p>
          </div>
          <div className="text-2xl font-extrabold text-violet-600">{pct}%</div>
        </div>
        <Progress value={pct} className="mt-4 h-2" />
      </Card>

      <div className="space-y-2">
        {forms.map((f) => (
          <Card key={f.id} className="cursor-pointer transition-colors hover:border-violet-200">
            <button onClick={() => setOpenId(f.id)} data-testid={`open-form-${f.id}`} className="flex w-full items-center justify-between gap-4 text-left">
              <div className="flex items-center gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-violet-100 text-violet-600"><ClipboardList className="h-5 w-5" /></div>
                <div>
                  <div className="font-semibold text-slate-900">{f.title} {f.required ? <span className="text-xs font-medium text-rose-500">Required</span> : <span className="text-xs text-slate-400">Optional</span>}</div>
                  <div className="text-sm text-slate-500">{LABEL[f.submission_status]}</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <StatusBadge status={BADGE[f.submission_status] || "Missing"} />
                <ChevronRight className="h-5 w-5 text-slate-300" />
              </div>
            </button>
          </Card>
        ))}
        {forms.length === 0 && <Card><p className="py-6 text-center text-sm text-slate-400">No forms published yet.</p></Card>}
      </div>

      <div className="pt-2">
        <h2 className="mb-3 text-base font-bold text-slate-900">Document uploads</h2>
        <Documents embedded />
      </div>
    </div>
  );
}
